import image from '../../img/layouts/newsela-logo.png';

export const preview = {
  image,
  description: 'Linear video',
};
